export function parseHashParams() {
  const params = new URLSearchParams(window.location.hash)
  const result = {}
  params.forEach((value, key) => { result[key] = value })
  return result
}

export function buildHashPath(path, params) {
  const query = Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join('&')
  return `${path}?${query}`
}
